<template>
    <div>
        <b-modal
            id="modalActivityHistory"
            ref="modalActivityHistory"
            :lazy="true"
            :scrollable="true"
            title-tag="h2"
            hide-footer
            title="History"
        >
            <!-- Modal Form -->
            <div v-if="activity_history.length">
                <section
                    id="cd-timeline"
                    v-for="history in activity_history"
                    :key="history.id"
                    class="cd-container"
                >
                    <div class="cd-timeline-block" style="margin-bottom: 10px;">
                        <div
                            class="cd-timeline-img cd-picture"
                            style="background: white;"
                        >
                            <i
                                :class="statusClass(history.status_id)"
                                class="famfamfam-silk"
                                style="margin: 0.75rem;"
                            ></i>
                        </div>
                        <!-- cd-timeline-img -->
                        <div class="cd-timeline-content">
                            <h2 class="pb-2">
                                {{ getTittle(history.status_id) }}
                            </h2>
                            <p
                                v-html="getDescription(history)"
                                style="
                                    word-break: break-all;
                                    border-top: 1px dotted #ccc;
                                "
                            ></p>
                            <span class="cd-date"
                                >{{ getCreateAt(history) }} by
                                {{ history.created_by.display_name }}</span
                            >
                        </div>
                        <!-- cd-timeline-content -->
                    </div>
                    <!-- cd-timeline-block -->
                </section>
            </div>
            <div v-else class="cd-container">
                <div class="cd-timeline-block" style="margin-bottom: 10px;">
                    No history data available
                </div>
            </div>
        </b-modal>
    </div>
</template>
<style lang="scss">
#modalActivityHistory div.modal-body {
    background-color: #f9f9f9;
}
#cd-timeline > div div.cd-timeline-content > {
    box-shadow: 0 3px 0 #ddd;
    & h2 {
        font-size: 0.85rem;
        padding-top: 3%;
    }
    & * {
        font-size: 0.75rem;
    }
    & .cd-date {
        font-size: 0.7rem;
        opacity: 0.6;
        padding: 0.8em 0;
    }
}
</style>

<script>
import moment from "moment";
import ScheduleHelper from "@/module/schedule/helper";
export default {
    mixins: [ScheduleHelper],
    data() {
        return {
            activity_history: []
        };
    },
    methods: {
        open(activity) {
            this.getActivityLog(activity.id);
        },
        getActivityLog(activityID) {
            let self = this;

            this.$http
                .get(
                    process.env.BARRAMUNDI +
                        "schedule/activity-history/" +
                        activityID
                )
                .then(function (response) {
                    self.activity_history = response.data.response.resources;
                });
            self.$refs.modalActivityHistory.show();
        },
        getTittle(status) {
            switch (status) {
                case 0:
                    return "Activity created";
                case 4:
                    return "Activity created";
                case 1:
                    return "Activity completed";
                case 2:
                    return "Activity completed";
                case 3:
                    return "Activity deactivated";
                case 5:
                    return "Activity edited";
                case 6:
                    return "Activity reactivated";
                default:
                    break;
            }
        },
        statusClass(status) {
            switch (status) {
                case 0:
                    return "cus-add"; //created
                case 4:
                    return "cus-add"; //created
                case 1:
                    return "cus-accept"; //completed
                case 2:
                    return "cus-accept"; //completed
                case 3:
                    return "cus-delete"; //deactivated
                case 5:
                    return "page_white_edit"; //edited
                case 6:
                    return "cus-arrow-refresh"; //reactivated
                default:
                    return "date_error";
            }
        },
        getDescription(history) {
            var summary = "";

            if (history.note) {
                summary = history.note;
            }

            return summary;
        },
        getCreateAt(history) {
            var summary = "";

            if (history.iso_create_at) {
                summary = moment(history.iso_create_at)
                    .tz(this._timeZone)
                    .format(this.getDateFormat() + " h:mm A");
            }

            return summary;
        }
    }
};
</script>
